/* LV 28.09.2026: okienko "Powiadom o dostepnosci" (RestockRooster) - zamiast pelnego tytulu produktu
   pokazujemy marke, nazwe PL, nazwe EN i pojemnosc (jak w naglowku karty). Dane z #lv-powiadom-dane. */
(function () {
  var zrodlo = document.getElementById('lv-powiadom-dane');
  if (!zrodlo) return;
  var d; try { d = JSON.parse(zrodlo.textContent); } catch (e) { return; }
  var esc = function (s) { var x = document.createElement('span'); x.textContent = s || ''; return x.innerHTML; };
  var html = (d.marka ? '<span class="lv-pow__marka">' + esc(d.marka) + '</span>' : '') +
    (d.t2 ? '<span class="lv-pow__t2">' + esc(d.t2) + '</span>' : '') +
    (d.t1 ? '<span class="lv-pow__t1">' + esc(d.t1) + '</span>' : '') +
    (d.poj ? '<span class="lv-pow__poj">' + esc(d.poj) + '</span>' : '');
  var popraw = function () {
    var t = document.getElementById('backInStockFormFullTitle');
    if (t && (d.t1 || d.t2) && t.getAttribute('data-lv') !== '1') { t.innerHTML = html; t.setAttribute('data-lv', '1'); }
    var tyt = document.querySelector('#backInStockForm .back-in-stock-form-header-text');
    if (tyt && tyt.textContent.trim() !== 'Powiadom o dostępności') tyt.textContent = 'Powiadom o dostępności';
    var btn = document.getElementById('backInStockFormButton');
    if (btn && !btn.disabled && btn.textContent.trim() !== 'Powiadom o dostępności' && /Powiadom mnie/i.test(btn.textContent)) btn.textContent = 'Powiadom o dostępności';
    var img = document.getElementById('backInStockFormVariantImage');
    if (img && (!img.alt || img.alt === 'null')) img.alt = d.nazwa || '';
  };
  var obs = new MutationObserver(function () {
    var t = document.getElementById('backInStockFormFullTitle');
    if (t && t.getAttribute('data-lv') === '1' && !t.querySelector('.lv-pow__t2, .lv-pow__t1')) t.removeAttribute('data-lv');
    popraw();
  });
  var start = function () { popraw(); obs.observe(document.body, { childList: true, subtree: true, characterData: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
